<template>
  <div>
    <div class="contain" id="jumppro">
        <p class="title">{{getLan('a349fba1-2ccd-412c-8576-0d0e6ebb2869')}}</p>
        <div class="image-box">
            <img src="@/assets/product/product_all.png" class="awards">
        </div>
    </div>
    <a href="./#/product" v-show="false" id="goPro" target="_blank"/>
    <a v-show="false" href="./#/allGame" id="goGame" target="_blank"/>
  </div>
</template>
<script>
// import product from '@/'
export default {
    data() {
        return {
        }
    },
    methods: {
        goPro() {
            document.querySelector('#goPro').click()
        },
        goGame() {
            document.querySelector('#goGame').click()
        },
    }

}
</script>

<style scoped>
.title {
    font-size: 2.09rem;
    font-weight: bold;
    padding-left:20rem;
    line-height: 3.8rem;
    color: #303030;
}
.image-box{
    display: flex;
    justify-content: center;
}
.contain {
    position: relative;
    padding-top: 5.97rem;
    width: 100rem;
    box-sizing: border-box;
    background: linear-gradient(#f7f9fb, #ffffff)
}
.awards {
    width:60rem;
    display: block;
    object-fit: cover;
    height: 40rem;
}

@media (min-width: 1156px){
  .awards {
    width:60rem;
    max-height: 30rem;
  }
  .title {
    padding-left:20rem;
  }
}
@media (max-width: 1156px){
  .awards {
    width:80rem;
    max-height: 50rem;
  }
  .title {
    padding-left:10rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Product.vue